import { makeNotifierProvider } from '@provider/notifier';
import { DialogContainer } from './organism.dialog-container.js';
import { ModalContainer } from './organism.modal-container.js';
import { ToastsContainer } from './organism.toast-container.js';

const UIKitNotifierProvider = makeNotifierProvider({
  name: "ui-kit",
  ui: {
    // NB: The notifications container assumes a parent that positions it in the
    // correct location of the DOM (e.g. by using createPortal), as well as the
    // placement of the notifications taking padding etc. into account.
    Toasts: ToastsContainer,
    Modals: ModalContainer,
    Dialogs: DialogContainer
  }
});

export { UIKitNotifierProvider };
//# sourceMappingURL=provider.js.map
